import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Backdrop from "@mui/material/Backdrop";

const Loader = ({ isLoading }) => {
  return (
    <Backdrop
      data-testid="loader-backdrop"
      sx={{
        color: "#fff",
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
      open={isLoading}
    >
      <CircularProgress data-testid="loader-spinner" />
      <Box sx={{ mt: 2 }}>Loading...</Box>
    </Backdrop>
  );
};

export default Loader;
